import Dispatcher from '../dispatcher';
import { CrossSellRemoveLightBoxActions } from '../constants/cross_sell_remove_light_box/cross_sell_remove_light_box_actions';

function showAction(payload) {
    Dispatcher.handleCrossSellRemoveLightboxAction({
        type: CrossSellRemoveLightBoxActions.SHOW,
        payload,
    });
}

function hideAction() {
    Dispatcher.handleCrossSellRemoveLightboxAction({
        type: CrossSellRemoveLightBoxActions.HIDE
    });
}

function expandAction() {
    Dispatcher.handleCrossSellRemoveLightboxAction({
        type: CrossSellRemoveLightBoxActions.EXPAND
    });
}

function crossSellRemoveInvalidAction(invalidMessage) {
    Dispatcher.handleCrossSellRemoveLightboxAction({
        type: CrossSellRemoveLightBoxActions.CROSS_SELL_REMOVE_INVALID_ACTION,
        payload: invalidMessage || getTranslatedText('message-invalid-request'),
    });
}

export {
    showAction,
    hideAction,
    expandAction,
    crossSellRemoveInvalidAction,
};
